import { render } from "./ArtikelDetailPage.vue?vue&type=template&id=7e78ed92"
import script from "./ArtikelDetailPage.vue?vue&type=script&lang=js"
export * from "./ArtikelDetailPage.vue?vue&type=script&lang=js"

import "./ArtikelDetailPage.vue?vue&type=style&index=0&id=7e78ed92&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__